<p-autocomplete
  appendTo="body"
  [suggestions]="filteredSurchargeTypes"
  [ngModel]="surchargeType"
  (ngModelChange)="onSurchargeTypeChange($event)"
  (completeMethod)="filterSurchargeType($event)"
  [showEmptyMessage]="true"
  [disabled]="disabled()"
>
</p-autocomplete>
